import { defineStore } from "pinia";

export const useUserStore = defineStore("user", {
  state: () => ({
    userData: null,
    showLogin: false,
    isLogged: false,
    userToken: null,
    userWebinarTerminId: null,
  }),
  actions: {
    setLoginView(data) {
      this.showLogin = data;
    },
    closeLogin() {
      this.showLogin = false;
    },
    setUser(data) {
      this.userData = data;
    },
    setToken(data) {
      this.userToken = data;
    },
    setWebinarTerminId(data) {
      this.userWebinarTerminId = data;
    },
  },
});
